import 'angular';

import { TiremetrixErrors }             from './tiremetrix.errors.directive';
import { TiremetrixFixErrorsCtrl }      from './tiremetrix.fix-errors';
import { TiremetrixRegisterTiresCtrl }  from './tiremetrix.register-tires';
import { TiremetrixStates }             from './tiremetrix.states.ajs';
import { TiremetrixSearchTiresCtrl }    from './tiremetrix.search-tires';
import { TiremetrixWarnings }           from './tiremetrix.warnings.directive';
import { TiremetrixSettingsCtrl }       from './tiremetrix.settings';
import { TiremetrixService }            from './tiremetrix.service';


angular.module('workshop.tiremetrix', [])
.config(TiremetrixStates)
.controller('TiremetrixFixErrorsCtrl', TiremetrixFixErrorsCtrl)
.controller('TiremetrixRegisterTiresCtrl', TiremetrixRegisterTiresCtrl)
.controller('TiremetrixSearchTiresCtrl', TiremetrixSearchTiresCtrl)
.controller('TiremetrixSettingsCtrl', TiremetrixSettingsCtrl)
.directive('tiremetrixErrors', TiremetrixErrors)
.directive('tiremetrixWarnings', TiremetrixWarnings)
.factory('Tiremetrix', TiremetrixService);
